module.exports = __webpack_public_path__ + "static/media/12.9504a1f2.jpg";